import { request } from "services/api/util";

class ServiceMasterService {
  async getListServiceMaster(params) {
    const config = {
      method: "get",
      url: `admin/services`,
      params: params,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailServiceMaster(id) {
    const config = {
      method: "get",
      url: `admin/services/${id}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createServiceMaster(body) {
    const config = {
      method: "post",
      url: `admin/services`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async updateServiceMaster(id, body) {
    const config = {
      method: "put",
      url: `admin/services/${id}`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ServiceMasterService();
